/* 🤖 this file was generated by svg-to-ts */
export const matIconAirlineSeatLegroomReduced: {
  name: 'airline-seat-legroom-reduced';
  data: string;
} = {
  name: 'airline-seat-legroom-reduced',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2zM5 12V3H3v9c0 2.76 2.24 5 5 5h4v-2H8c-1.66 0-3-1.34-3-3z"/></svg>`
};
